import { Component, ComponentFactoryResolver, OnInit, Type } from '@angular/core';
import { UserConfigService } from 'src/app/services/user-config.service';
import { EHealthService } from 'src/app/services/e-health.service';
import { LegacyContentService } from 'src/app/services/legacy-content.service';
import { faUserCircle, faHouseUser } from '@fortawesome/pro-solid-svg-icons';
import { BecareService } from 'src/app/services/becare.service';
import { MatDialog } from '@angular/material/dialog';
import { EHealthDialogComponent } from 'src/app/dialogs/e-health-dialog/e-health-dialog.component';
import { EHealthMessageDialogComponent } from 'src/app/dialogs/e-health/e-health-message-dialog/e-health-message-dialog.component';
import { TypeManagerService } from 'src/app/services/type-manager.service';

@Component({
  selector: 'app-userinfo',
  templateUrl: './userinfo.component.html',
  styleUrls: ['./userinfo.component.scss']
})
export class UserinfoComponent implements OnInit {

  faUserCircle = faUserCircle;
  faHouseUser = faHouseUser;

  retrievingehealthbox = false;
  sendingehealthbox = false;

  constructor(public userConfig: UserConfigService, public ehealth: EHealthService,
              private legacyContent: LegacyContentService, private becare: BecareService,
              private dialog: MatDialog, private resolver: ComponentFactoryResolver,
              private typeManager: TypeManagerService) { }

  ngOnInit(): void {
  }

  menuClick(menu)
  {
      if (typeof menu.execute !== 'undefined')
      {
          // tslint:disable-next-line:no-eval
          eval(menu.execute);
      }
      if (typeof menu.loadcontent !== 'undefined')
      {
          if (typeof menu.loadcontent === 'string')
          {
            this.legacyContent.LoadContent(menu.loadcontent);
          }
          else
          {
            this.legacyContent.LoadContent(menu.loadcontent[0], menu.loadcontent[1], menu.loadcontent[2]);
          }
      }
      if (typeof menu.dialog !== undefined) {
        // Load dialog
        if (this.typeManager.typeMap(menu.dialog)) {
          const componentFactory = this.typeManager.typeMap(menu.dialog);
          const dialogRef = this.dialog.open(componentFactory, {
              data: {

              },
              minHeight: '80%',
              minWidth: '80%'
          });
          dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }
      }
  }

  groupSwitchClick(group) {
    // Unset current group
    let userdomain;
    for (const usergroup of this.userConfig.config.groups) {
      if (usergroup.maingroup === true) {
        for (const maingroup of this.userConfig.switchGroups) {
          if (maingroup.name === usergroup.name) {
            userdomain = maingroup;
          }
        }
      }
    }
    if (userdomain) {
      this.becare.call('/user/' + this.userConfig.userid  + '/domain/' + userdomain.id, [], undefined, 'delete').subscribe(deleteresult => {
        // Set current group
        this.becare.call('/user/' + this.userConfig.userid  + '/domain/' + group.id, [], undefined, 'put').subscribe(putresult => {
          // Reload user config
          this.userConfig.loadConfig();
        });
      });
    } else {
      this.becare.call('/user/' + this.userConfig.userid  + '/domain/' + group.id, [], undefined, 'put').subscribe(putresult => {
        // Reload user config
        this.userConfig.loadConfig();
      });
    }
  }

  logout() {
    this.becare.unAuthenticate();
  }

  showEHealthPanel()
  {
      const dialogRef = this.dialog.open(EHealthDialogComponent);
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });
  }

  showEHealthMessagePanel(inout)
  {
    const dialogRef = this.dialog.open(EHealthMessageDialogComponent, {
        data: {
            box: inout
        },
        minWidth: '80%'
    });
    dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
    });
  }

  groupClass(group) {
    for (const usergroup of this.userConfig.config.groups) {
      if (usergroup.name === group.name && usergroup.maingroup === true) {
        return 'user-domainname';
      }
    }
    return '';
  }
}
